/**
 * Enum representing the various statuses a demand can have.
 * 
 * @enum {string}
 * @property {string} Open - The demand is currently open.
 * @property {string} OpenOnHold - The demand is open but on hold.
 * @property {string} OpenSourcing - The demand is open and in the sourcing phase.
 * @property {string} Resolved - The demand has been resolved.
 * @property {string} Dropped - The demand has been dropped.
 * @property {string} Lost - The demand has been lost.
 * @property {string} ClarificationNeeded - The demand needs more details, information, etc.
 */
export enum DemandStatus {
  Open = "Open",
  OpenOnHold = "Open (on hold)",
  OpenSourcing = "Open (sourcing)",
  Resolved = "Resolved",
  Dropped = "Dropped",
  Lost = "Lost",
  ClarificationNeeded = "Clarification needed"
}